// Aquí está el slice de evento
import { createSlice } from "@reduxjs/toolkit";
// import { crearEvento } from "./eventoThunks";

const initialState = {
  infoPublicEventos: null,
  failurePublicEventos: false,
  errorPublicEventos: null,
  isLoadingPublicEventos: false,
  // 📝 Estado de paginación
  currentPage: 1,
  totalPages: 0,
  totalItems: 0,
  hasNextPage: false,
  hasPrevPage: false,
  // 📝 Filtros actuales aplicados
  currentFilters: {},
  // 📝 TTL Cache - 5 minutos (300000 ms)
  lastFetchTimestamp: null,
  cacheTTL: 300000, // 5 minutos en milisegundos
};

const publicEventosSlice = createSlice({
  name: "publicEventos",
  initialState,
  reducers: {
    publicEventosSuccess: (state, action) => {
      // Reemplazar eventos (para nueva búsqueda/filtrado)
      state.infoPublicEventos = action.payload.infoPublicEventos;
      
      // Actualizar paginación
      if (action.payload.pagination) {
        state.currentPage = action.payload.pagination.currentPage || 1;
        state.totalPages = action.payload.pagination.totalPages || 0;
        state.totalItems = action.payload.pagination.totalItems || 0;
        state.hasNextPage = action.payload.pagination.hasNextPage || false;
        state.hasPrevPage = action.payload.pagination.hasPrevPage || false;
      }
      
      // Guardar filtros actuales
      if (action.payload.filters) {
        state.currentFilters = action.payload.filters;
      }
      
      // Actualizar timestamp del cache
      state.lastFetchTimestamp = Date.now();
      
      state.failurePublicEventos = false;
      state.isLoadingPublicEventos = false;
    },
    
    appendPublicEventos: (state, action) => {
      // Agregar eventos a la lista existente (para paginación/load more)
      if (state.infoPublicEventos && action.payload.eventos) {
        state.infoPublicEventos = [...state.infoPublicEventos, ...action.payload.eventos];
      } else {
        state.infoPublicEventos = action.payload.eventos;
      }
      
      // Actualizar paginación
      if (action.payload.pagination) {
        state.currentPage = action.payload.pagination.currentPage || state.currentPage;
        state.totalPages = action.payload.pagination.totalPages || state.totalPages;
        state.totalItems = action.payload.pagination.totalItems || state.totalItems;
        state.hasNextPage = action.payload.pagination.hasNextPage || false;
        state.hasPrevPage = action.payload.pagination.hasPrevPage || false;
      }
      
      state.isLoadingPublicEventos = false;
    },
    
    publicEventosFailure: (state, action) => {
      state.failurePublicEventos = true;
      state.isLoadingPublicEventos = false;
      state.errorPublicEventos = action.payload; // mensaje de errorPublicEventos
    },
    
    publicEventosReset: (state) => {
      state.infoPublicEventos = null;
      state.failurePublicEventos = false;
      state.errorPublicEventos = null;
      state.isLoadingPublicEventos = false;
      state.currentPage = 1;
      state.totalPages = 0;
      state.totalItems = 0;
      state.hasNextPage = false;
      state.hasPrevPage = false;
      state.currentFilters = {};
      state.lastFetchTimestamp = null;
    },
    
    setLoadingPublicEventos: (state, action) => {
      state.isLoadingPublicEventos = action.payload;
    },
    
    // Invalidar cache manualmente si es necesario
    invalidateCache: (state) => {
      state.lastFetchTimestamp = null;
    },
  },
  // extraReducers: (builder) => {
  //   builder
  //     // Crear publicEventos
  //     .addCase(crearpublicEventos.pending, (state) => {
  //       state.isLoadingpublicEventos = true;
  //       state.failurePublicEventos = false;
  //       state.errorpublicEventos = null;
  //     })
  //     .addCase(crearpublicEventos.fulfilled, (state, action) => {
  //       state.isLoadingpublicEventos = false;
  //       state.failurePublicEventos = false;
  //       state.infoPublicEventos = action.payload;
  //       state.errorpublicEventos = null;
  //     })
  //     .addCase(crearpublicEventos.rejected, (state, action) => {
  //       state.isLoadingpublicEventos = false;
  //       state.failurePublicEventos = true;
  //       state.errorpublicEventos = action.payload;
  //     });
  // },
});


export const {
  publicEventosSuccess,
  publicEventosFailure,
  publicEventosReset,
  appendPublicEventos,
  setLoadingPublicEventos,
  invalidateCache,
} = publicEventosSlice.actions;
export default publicEventosSlice.reducer;